import React from 'react';
import { TranslationKeys, PostProcessKeys } from 'translations';
import { DjangoListResponse, DataVendor } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { useTranslation } from 'react-i18next';
import FilterDropdown from 'v2/form/CustomSelectors/FilterDropdown';

type FetchDataVendorsProps = {
  searchInput?: string;
};

async function fetchInfiniteDataVendors({
  searchInput,
}: FetchDataVendorsProps) {
  const options: Record<string, string> = {
    ordering: 'name',
  };

  if (searchInput) options['name__icontains'] = searchInput;

  return await restFactory.get<DjangoListResponse<DataVendor>>(
    '/dj/api/v1/data_vendor/',
    options
  );
}

async function loadDataVendorOptions(searchInput: string) {
  let dataVendors: DataVendor[] = [];

  try {
    const dataVendorsData = await fetchInfiniteDataVendors({
      searchInput,
    });
    dataVendors = dataVendorsData.results;
  } catch {
    return [];
  }

  const dataVendorOptions = dataVendors.map((dataVendor) => ({
    label: dataVendor.name ?? dataVendor.domain,
    value: dataVendor,
  }));

  return dataVendorOptions;
}

type DataVendorSelectorProps = {
  onChange: (option?: DataVendor) => void;
  value?: DataVendor | null;
};

export function DataVendorSelector({
  onChange,
  value,
}: DataVendorSelectorProps) {
  const { t } = useTranslation();
  const option = value
    ? {
        label: value.name,
        value,
      }
    : null;

  return (
    <FilterDropdown
      value={option}
      loadOptions={loadDataVendorOptions}
      defaultValue={null}
      defaultOptions
      onChange={onChange}
      placeHolder={`Select ${t(TranslationKeys.company_one, {
        postProcess: PostProcessKeys.TitleCase,
      })}`}
    />
  );
}
